import React from "react";
import styles from "./SubscriptionsPillsSection.module.scss";

export function SubscriptionLanguagePills({ values, onToggle }) {
  return (
    <div className={styles.langPills} aria-label="Select language">
      {values.map(({ code, label, selected, disabled }) => (
        <button
          key={code}
          type="button"
          disabled={disabled}
          className={`${styles.langPill} ${selected ? styles.langPillActive : ""} ${disabled ? styles.langPillDisabled : ""}`}
          onClick={() => onToggle(code)}
          aria-pressed={selected}
          aria-disabled={disabled}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
